import SettingsDialog from '@/app/components/DialogSettings';
import Button from "@ergeon/core-components/exports/Button.ts";

import { AdjustmentsHorizontalIcon } from "@heroicons/react/24/outline";
import { EVENTS, gtag } from '@/lib/gtag';

export default function ButtonSettings() {
  const onButtonClick = () => {
    gtag(EVENTS.OPEN_SETTINGS);
  }

  return (
    <SettingsDialog>
      <Button
        flavor="regular"
        isSquare
        onClick={onButtonClick}
        size="large"
        title="Settings"
      >
        <AdjustmentsHorizontalIcon className="size-6" />
      </Button>
    </SettingsDialog>
  );
}
